module.exports = __webpack_public_path__ + "91e472682b0c7131d51138fdffce9d01.svg";